export const MINUTES_THRESHOLD_FOR_MARKET_STATUS_CHANGE_NOTIFICATIONS = 30;
